"use client";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { countryName, flagUrl } from "@/lib/countries";
import { useCountry, useCountryStore } from "@/lib/country-store";
import { useLocale, useMessages } from "@/lib/i18n/client";
import { track } from "@/lib/tracking/track";
import { cn } from "@/lib/utils";
import messages from "./country-switcher.i18n";

// Selector de país global (junto al de idioma): define qué eventos,
// ubicaciones y organizaciones se muestran, y el catálogo de Viva Cine.
export function CountrySwitcher({ className }: { className?: string }) {
  const t = useMessages(messages);
  const lang = useLocale();
  const { country } = useCountry();
  const setCountry = useCountryStore((s) => s.setCountry);
  // Fijos + países con eventos vigentes (ver country-store).
  const available = useCountryStore((s) => s.available);

  function change(next: string) {
    if (next === country) return;
    setCountry(next);
    track("country_change", { country: next });
  }

  return (
    <Select value={country} onValueChange={change}>
      <SelectTrigger
        aria-label={t.label}
        className={cn("h-7 w-auto gap-1.5 border-0 bg-transparent px-1.5 text-xs font-semibold shadow-none", className)}
      >
        <SelectValue>
          <span className="flex items-center gap-1.5">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={flagUrl(country)} alt="" width={16} height={12} className="rounded-[2px]" />
            {country}
          </span>
        </SelectValue>
      </SelectTrigger>
      {/* Sobre el header (z-[1100]) y el aviso de cookies (z-[1250]). */}
      <SelectContent align="end" className="z-[1300]">
        {available.map((code) => (
          <SelectItem key={code} value={code}>
            <span className="flex items-center gap-2">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src={flagUrl(code)} alt="" width={16} height={12} className="rounded-[2px]" />
              {countryName(code, lang)}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
